import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "icn-graphics-text-link",
  templateUrl: "./text-link.component.html",
  styleUrls: ["./text-link.component.scss"],
})
export class GraphicsTextLinkComponent {
  @Input()
  link: string;

  @Output()
  linkChange = new EventEmitter<string>();
}
